import Vue from 'vue';

Vue.filter('foreverTime', (date) => {
  let time = parseInt(date.split('-')[0]);
  if (typeof date === 'string' && time >= 3000) {
    return '永久';
  } else {
    return date;
  }
});

Vue.filter('hideMobileNum', (mobile) => {
  return mobile && `${mobile.slice(0, 3)}****${mobile.slice(7)}`;
});



// WEBPACK FOOTER //
// ./src/js/util.js